<template>
  <div class="grocery-bag-block">
    <div class="row-noGutter grocery-bag-block__heading">
      <div class="col-12">
        <h3 class="grocery-bag-block__heading-pre">
          ICAS MATKASSE
        </h3>
        <h3 class="grocery-bag-block__heading-name">
          {{ name }}
        </h3>
      </div>
    </div>
    <div class="row-noGutter">
      <div class="col-12 grocery-bag-block__media">
        <cloudinary-picture
          :url="imageUrl"
          :sizes="dimensions"
          :sharpen="80"
          auto-quality="best"
          :use-picture="false"
          :aspect-ratio="aspectRatio"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12 grocery-bag-block__content">
        <p
          v-if="showDescription"
          class="grocery-bag-block__content-description"
        >
          {{ description }}
        </p>

        <a
          v-if="recipeLink"
          class="button--white  button--40 grocery-bag-block__recipe-link"
          :href="recipeLink"
        > <svgicon
          class=""
          name="Cooking/Recipe"
        /> Se veckans meny</a>
      </div>
    </div>
    <div class="row">
      <div class="col-12 grocery-bag-block__footer">
        <div class="row-noGutter">
          <div class="col-4_sm-6 grocery-bag-block__foooter-price">
            <grocery-bag-price-splash
              :color="color"
              :offer="offer"
              :current-price="currentPrice"
              :current-price-recommended="currentPriceRecommended"
            />
          </div>
          <div class="col-8_sm-6 grocery-bag-block__foooter-radio">
            <div class="grocery-bag-block__footer-radio-row">
              <strong
                v-if="peoples"
                class="order-label in-block"
              >
                Portioner
              </strong>
              <p
                v-if="peoples"
                class="radio-wrapper"
              >
                <template
                  v-for="person in peoples"
                >
                  <input
                    :id="name + '-' + person"
                    :key="'input' + name + '-' + person"
                    v-model="selectedPersons"
                    :value="person"
                    :name="name"
                    type="radio"
                  >
                  <label
                    :key="'label-' + name + '-' + person"
                    :for="name + '-' + person"
                  >{{ person }}</label>
                </template>
              </p>
            </div>
            <div class="grocery-bag-block__footer-radio-row">
              <strong
                v-if="days"
                class="order-label in-block"
              >
                Dagar
              </strong>
              <p
                v-if="days"
                class="radio-wrapper"
              >
                <template
                  v-for="day in days"
                >
                  <input
                    :id="name + '-day-target-' + day"
                    :key="'day-' + day"
                    v-model="selectedDays"
                    :value="day"
                    :name="'day-target-' + name"
                    type="radio"
                    :disabled="!isDaysAvailable(day)"
                  >
                  <label
                    :key="'day-label-' + day"
                    :for="name + '-day-target-' + day"
                  >{{ day }}</label>
                </template>
              </p>
            </div>
            <grocery-bag-order-check-box
              :gluten-free="glutenFree"
              :lactose-free="lactoseFree"
              :products="products"
              :is-gluten-free-available="isGlutenFreeAvailable"
              :is-lactose-free-available="isLactoseFreeAvailable"
              :name="name"
              @lactoseFreeChange="doChangeLactoseFree"
              @glutenFreeChange="doChangeGlutenFree"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="grocery-bag-block__last-row row-noGutter">
      <button
        v-if="!storeLink"
        class="button button--40 button-primary button--fullwidth"
        @click="pickStore"
      >
        Välj butik
      </button>

      <template v-if="isAddOn">
        <a
          v-if="storeLinkOneTime"
          class="button button--40 button-primary button--fullwidth"
          :href="storeLinkOneTime"
        >
          Köp {{ name.toLowerCase() }}
        </a>
      </template>

      <template v-else>
        <div>
          <a
            v-if="storeLink"
            class="button button--40 button-primary button--fullwidth"
            :href="storeLink"
          >
            Abonnera på {{ name.toLowerCase() }}
          </a><a
            v-if="storeLinkOneTime"
            class="one-time-buy button button--40 button--secondary button--fullwidth"
            :href="storeLinkOneTime"
          >
            Engångsköp
          </a>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import GroceryBagOrderCheckBox from '@/vue/components/groceryBagComponents/groceryBagOrderCheckBox.vue'
import GroceryBagPriceSplash from '@/vue/components/groceryBagComponents/groceryBagPriceSplash'
import '#/Cooking/Recipe'

export default {
  name: "GroceryBagBlock",
  components: {
    'grocery-bag-order-check-box': GroceryBagOrderCheckBox,
    'grocery-bag-price-splash': GroceryBagPriceSplash
  },
  props: {
    showDescription: {
      type: Boolean,
      default: true
    },
    blockSize: {
      type: String,
      default: "third",
      validator (value) {
        return ["full", "half", "third", "quarter"].includes(value)
      }
    },
    id: {
      type: Number,
      default: 0
    },
    imageUrl: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    products: {
      type: Array,
      default: () => []
    },
    color: {
      type: String,
      default: "red"
    },
    link: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      dimensions: {
        small: {
          width: 196
        },
        medium: {
          width: 480
        },
        large: {
          width: 552
        }
      },
      glutenFree: null,
      lactoseFree: null,
      selectedPersons: null,
      selectedDays: null
    }
  },
  computed: {
    ...mapState([
      'store',
      'selectedDeliveryMethod'
    ]),
    currentPrice () {
      if (this.currentProduct === null) {
        return 0
      }

      if (!this.store && this.currentProduct.campaignPrice) {
        return this.currentProduct.campaignPrice
      }

      if (this.selectedDeliveryMethod === 'pickup'){
        if (this.currentProduct.offerPickup) {
          return this.currentProduct.pricePickup
        }
        return this.currentProduct.recommendedPricePickup
      }

      if (this.selectedDeliveryMethod === 'homeDelivery'){
        if (this.currentProduct.offerHomeDelivery) {
          return this.currentProduct.priceHomeDelivery
        }
        return this.currentProduct.recommendedPriceHomeDelivery
      }

      return this.currentProduct.recommendedPricePickup || this.currentProduct.recommendedPriceHomeDelivery
    },
    currentPriceRecommended () {
      if (this.currentProduct === null) {
        return 0
      }

      return this.selectedDeliveryMethod === "pickup" ?  this.currentProduct.recommendedPricePickup : this.currentProduct.recommendedPriceHomeDelivery
    },
    currentProduct () {
      let prods = this.products.filter(
        p => p.days === this.selectedDays
          && p.peoples === this.selectedPersons)

      if (this.glutenFree) {
        prods = prods.filter(
          p => p.glutenFree === !!this.glutenFree)
      }

      if (this.lactoseFree) {
        prods = prods.filter(
          p => p.lactoseFree === !!this.lactoseFree)
      }

      if (prods.length <= 0) {
        return null
      }
      return prods[0]
    },
    days () {
      const products = this.products.filter(
        p =>
          p.glutenFree === !!this.glutenFree &&
          p.lactoseFree === !!this.lactoseFree
      )

      const allDays = []
      for (const { days } of products) {
        allDays.push(days)
      }
      return new Set(allDays.sort())
    },
    isAddOn () {
      return this.currentProduct && this.currentProduct.isAddOn
    },
    offer () {
      const curr = this.currentProduct
      if (!curr) { return false }

      return (!this.store && !!curr.campaignPrice) || !!curr.offerPickup
    },
    peoples () {
        const products = this.products.filter(
        p =>
          p.glutenFree === this.glutenFree &&
          p.lactoseFree === this.lactoseFree
      )

      const allPeoples = []
      for (const { peoples } of products) {
        allPeoples.push(peoples)
      }
      return new Set(allPeoples.sort())
    },
    aspectRatio () {
      return this.$root.isSmallViewport ? 100 : 0
    },
    isGlutenFreeAvailable () {
      return this.products.some(
        p => p.peoples === this.selectedPersons
          && p.days === this.selectedDays
          && p.glutenFree)
    },
    isLactoseFreeAvailable () {
      return this.products.some(
        p => p.peoples === this.selectedPersons
          && p.days === this.selectedDays
          && p.lactoseFree)
    },
    recipeLink () {
      if (!this.link) {return}
      let realLink = this.link

      const qs = {}
      if (this.selectedPersons) {qs.p = this.selectedPersons}
      if (this.selectedDays) {qs.d = this.selectedDays}
      if (this.glutenFree) {qs.g = this.glutenFree}
      if (this.lactoseFree) {qs.l = this.lactoseFree}

      if (qs.p || qs.d || qs.g || qs.l) {
        const query = Object.keys(qs)
          .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(qs[k]))
          .join('&')

        realLink = `${realLink}?${query}`
      }

      return realLink
    },
    storeLink () {
      return this.makeStoreLink()
    },
    storeLinkOneTime () {
      return this.makeStoreLink(true)
    },
  },
  watch: {
    selectedPersons (val) {
      if (this.isDaysAvailable(this.selectedDays)) {
        return
      }

      // set selectedDays to the first item that has the current number of persons
      this.selectedDays = this.products.filter(p => p.peoples === val)[0].days
    },
    products (products) {
      if(products && products.length > 0) {
        this.setDefaultFilters()
      }
    }
  },
  created () {
    // Find 4 people or cheapest bag - if only some of the bags are lactose free or gluten free, do not filter with them
    this.setDefaultFilters()
  },
  methods: {
    ...mapMutations([
      'SHOW_STORE_PICKER'
    ]),
    setDefaultFilters () {
      let bags = this.products.filter(p => !p.glutenFree && !p.lactoseFree)

      if (bags.length == 0 || bags.length == this.products.length) {
        bags = this.products
      }

      if (bags.length) {
        const fourPeopleBags = bags.filter((b) => b.peoples === 4)
        const filteredBags = fourPeopleBags.length > 0 ? fourPeopleBags : bags
        const cheapest = filteredBags.reduce( 
          (prev, curr) => { 
            return prev.recommendedPriceHomeDelivery < curr.recommendedPriceHomeDelivery ? prev : curr
          })
        this.selectedDays = cheapest.days
        this.selectedPersons = cheapest.peoples
        this.lactoseFree = !!cheapest.lactoseFree
        this.glutenFree = !!cheapest.glutenFree
      }
    },
    isDaysAvailable (days) {
      if (this.selectedPersons === null) {
        return true
      }

      let prods = this.products.filter(
        p => p.peoples === this.selectedPersons)

      if (this.glutenFree) {
        prods = prods.filter(p => p.glutenFree === !!this.glutenFree)
      }

      if (this.lactoseFree) {
        prods = prods.filter(p => p.lactoseFree === !!this.lactoseFree)
      }
      return prods.some(p => p.days === days)
    },
    makeStoreLink (oneTime) {
      if (!this.store) { return }
      if (!this.currentProduct) { return }

      const discountCode = this.selectedDeliveryMethod === 'pickup'
        ? this.currentProduct.offerPickup
        : this.currentProduct.offerHomeDelivery

      const params = {
        storeid: this.store.id,
        productid: this.currentProduct.id,
        deliverytype: this.selectedDeliveryMethod.toLowerCase(),
      }

      if (discountCode) {
        params.discountcode = discountCode
      }

      if (oneTime) {
        params.purchasetype = 1
      }

      const query = Object.keys(params)
        .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
        .join('&')

      return `/handla-online/ica-matkassen/matkasse-checkout/?${query}`
    },
    pickStore () {
      this.SHOW_STORE_PICKER()
    },
    doChangeLactoseFree (value) {
      this.lactoseFree = value
    },
    doChangeGlutenFree (value) {
      this.glutenFree = value
    },
  }
}
</script>

<style lang="scss">
@import "groceryBagBlock";
</style>
